import { graphql, useStaticQuery } from 'gatsby'
import '@src/data/prismic-fragments/advisor'
import { CardDetailsType } from '@islandsstofa/react'

export default () => {
  const data = useStaticQuery(graphql`
    {
      allPrismicAdvisor(sort: { fields: data___name___text, order: ASC }) {
        nodes {
          ...prismicAdvisorFragmentFull
        }
      }
    }
  `)

  const advisors: CardDetailsType[] = data.allPrismicAdvisor.nodes.map(
    (node: {
      data: {
        name: {
          text: string
        }
        text: {
          html: string
        }
        logo: {
          alt: string | null
          url: string
        }
        website: {
          url: string
        }
      }
    }) => {
      return {
        name: node.data.name,
        excerpt: node.data.text,
        image: node.data.logo,
        url: node.data.website,
        website: node.data.website
      }
    }
  )

  return advisors
}
